// extracted by css-extract-rspack-plugin
export default {"invalid":"Sv8fGYzVURQ3ZjVm","header":"_wRVks2BFjoSd1DX","message":"Hlo3lRHhhlwNerno"};